import api from '@/utils/api';

/**
 * Update user
 * @param {object} accountPasswordData - The account password data
 * @returns {Promise}
 */
const updateAccountPasswordApi = (accountPasswordData) =>
  api.patch(`/user/my-account/password`, accountPasswordData);

export default updateAccountPasswordApi;
